
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic07On as ObiLogic07OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-07-on.js';
 
 
 

 
 export const ObiLogic07On = createComponent({
   react: React,
   tagName: 'obi-logic-07-on',
   elementClass: ObiLogic07OnElement,
   events: {
     
   }
  });
 
 